import { conditionApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_ACTION_CONDITION_ACTION_TYPE = createNamedActions('conditions', {
  GET_LOAN_ACTIONS_CONDITIONS: 'GET_LOAN_ACTIONS_CONDITIONS',
});

const conditions = new schema.Entity('conditions', {}, { idAttribute: 'conditionId' });

export const getLoanActionsConditionAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await conditionApi.getLoanActionsCondition();

  return dispatch({
    type: LOAN_ACTION_CONDITION_ACTION_TYPE.GET_LOAN_ACTIONS_CONDITIONS,
    payload: normalize(data, [conditions]).entities.conditions,
  });
});
